(function () {
  const subscribeForms = document.querySelectorAll(".two-step--signup form");
  subscribeForms.forEach((signup) => {

    const continueButton = signup.querySelector('.two-step--continue');
    const closeButton = document.querySelector('.two-step__close');
    const email = signup.querySelector('input[name="email"]');
    const phone = signup.querySelector('input[type="tel"]');
    let phoneNumber = false;

    this.itiTwoStep = intlTelInput(phone, {
      initialCountry: 'US'
    });

    if(closeButton) {
      closeButton.addEventListener('click',(e) => {
        e.target.closest('.section--two-step-signup').classList.add('hidden');
      });
    }

    continueButton.addEventListener('click',function(e) {
      e.preventDefault();
      if(email.value == '') {
        signup.querySelector('.messages').innerHTML = 'Please enter a valid email address';
        signup.querySelector('.messages').classList.remove('hidden');
        return;
      }
      signup.querySelector('.messages').classList.add('hidden');
      signup.querySelector('.two-step__step-1').classList.add('hidden');
      signup.querySelector('.two-step__step-2').classList.remove('hidden');

    });    

    const submit = signup.querySelector(".two-step--submit");

    signup.addEventListener("submit", function (e) {
      e.preventDefault();
      const listId = signup.querySelector('input[name="g"]').value;
      const successMessage = signup.getAttribute("data-success-message");
      const messages = signup.querySelector(".messages");
      const email = signup.querySelector('input[name="email"]');
      const subscribeUrl = "//manage.kmail-lists.com/ajax/subscriptions/subscribe";

      if (phone && phone.value === "") {
        messages.textContent = "Please enter a valid phone number";
        messages.classList.remove("hidden");
        return false;
      }

      const countryCode = signup.querySelector('.iti__selected-flag').getAttribute('title').split(': ')[1];
      phoneNumber = `${countryCode}${phone.value}`;


      const bodyContent = {
        g: listId,
        email: email.value,
        sms_consent: true,
        $fields: '$phone_number,sms_consent',
        $phone_number: phoneNumber,
        $consent: ['sms']
      };

      fetch(subscribeUrl, {
        body: new URLSearchParams(bodyContent),
        method: "POST",
      })
      .then((response) => response.json())
      .then((response) => {
        console.log(response);
        if (response.success) {
          messages.textContent = successMessage;
          if(window.location.href.indexOf('/pages/signup-new') > -1) {
            const redirectTo = '/collections/best-sellers?filter.v.availability=1';
            setTimeout(function() {
              window.location.href = redirectTo;
            },4000);
          }
        } else {
          messages.textContent = response.errors;
        }
        messages.classList.remove("hidden");
      })
      .catch((err) => {
        console.error(err);
      });

      return true;

    });
  });

})();

